import { getKeys } from './getKeys'

export const deviceRecordTranslations = {
  // Page Header
  DEVICE_RECORDS: 'Device Records',
  DEVICE_RECORDS_FOR: "{{name}}'s Device Records",
  ADD_DEVICE_RECORD: 'Add Device Record',
  DEVICE_RECORDS_TOOLTIP:
    'Record any equipment or assistive technology used to support a person, whether formally provided or used temporarily. This can include items like mobility aids, medical devices, or everyday equipment used in care.',

  // Modal
  DEVICE_RECORD: 'Device record',
  NAME: 'Name',
  NAME_REQUIRED: 'Name is required',
  NAME_PLACEHOLDER: 'Enter device record name',
  DESCRIPTION: 'Description',
  DESCRIPTION_PLACEHOLDER: 'Enter description (optional)',
  LOCATION: 'Location',
  LOCATION_PLACEHOLDER: 'Enter location (optional)',
  START_DATE: 'Start date',
  START_DATE_PLACEHOLDER: 'Select start date',
  END_DATE: 'End date',
  END_DATE_PLACEHOLDER: 'Select end date',
  DOCUMENTS: 'Documents',
  UPLOAD_DOCUMENT: 'Upload document',
  EXISTING_DOCUMENTS_INFO:
    '{{count}} existing documents. You can add {{remaining}} more.',
  MAX_ADDITIONAL_DOCUMENTS_ALLOWED:
    'Maximum {{count}} additional documents allowed',
  MAX_DOCUMENTS_ALLOWED: 'Maximum {{count}} documents allowed',
  CANCEL: 'Cancel',
  SAVE: 'Save',
  ADD: 'Add',

  // List
  NO_DEVICE_RECORDS_FOUND: 'No device records found',
  NO_DEVICE_RECORDS_DESCRIPTION:
    'There are no device records recorded for this resident yet.',
  NO_DATE_TIME_SPECIFIED: 'No date/time specified',
  ARCHIVED_DEVICE_RECORDS: 'Archived Device Records',
  DEVICE_PERIOD: 'Device period',
  HAS_ATTACHMENT: 'Has attachment',
  DOCUMENT_NUMBER: 'Document {{number}}',

  // Actions
  EDIT: 'Edit',
  ARCHIVE: 'Archive',
  ARCHIVED: 'Archived',
  ACTIVE: 'Active',
  IN_USE: 'In Use',
  UN_ARCHIVE: 'Un-archive',
  RESTORE: 'Restore',
  CREATED_BY: 'Created by',
  UPDATED_BY: 'Updated by',
  ON: 'on',
  REMOVE_DOCUMENT: 'Remove Document',
  REMOVE_DOCUMENT_CONFIRMATION:
    'Are you sure you want to remove "{{filename}}"? This action cannot be undone.',
  REMOVE: 'Remove',
  DOCUMENT_NO_LONGER_AVAILABLE: 'Document is no longer available',

  // Archive Modal
  ARCHIVE_DEVICE_RECORD: 'Archive Device Record',
  RESTORE_DEVICE_RECORD: 'Restore Device Record',
  ARCHIVE_CONFIRMATION:
    'Are you sure you want to archive this device record? You can restore it later if needed.',
  RESTORE_CONFIRMATION:
    'Are you sure you want to restore this device record to active status?'
}

export const deviceRecordConstants = getKeys(deviceRecordTranslations)
